interface Props {
    className?: string
    FillColor?: string
}

export default function Interview({className, FillColor}:Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
            <path
                d="M22.5 5.25C22.5 3.17893 20.8211 1.5 18.75 1.5H8.25C6.41365 1.5 4.88559 2.81994 4.56282 4.56282C2.81994 4.8856 1.5 6.41365 1.5 8.25V14.25C1.5 16.3211 3.17893 18 5.25 18H6V21.4239C6 22.1928 6.9019 22.6076 7.48571 22.1072L11.1895 18.9325L12.1035 18.155C12.2297 18.0476 12.2449 17.8582 12.1375 17.7321C11.7079 17.2274 10.9505 17.1666 10.4459 17.5962L10.23 17.7799L7.5 20.1193V17.4C7.5 16.9029 7.09706 16.5 6.6 16.5H5.25C4.00736 16.5 3 15.4926 3 14.25V8.25C3 7.27034 3.6261 6.43691 4.5 6.12803V11.25C4.5 13.3211 6.17893 15 8.25 15H11.7226L16.5143 19.1072C17.0981 19.6076 18 19.1928 18 18.4239V15H18.75C20.8211 15 22.5 13.3211 22.5 11.25V5.25ZM18.75 3C19.9926 3 21 4.00736 21 5.25V11.25C21 12.4926 19.9926 13.5 18.75 13.5H17.4C16.9029 13.5 16.5 13.9029 16.5 14.4V17.1193L12.5302 13.7167C12.3671 13.5769 12.1594 13.5 11.9445 13.5H8.25C7.00736 13.5 6 12.4926 6 11.25V5.25C6 4.00736 7.00736 3 8.25 3H18.75Z"
                fill={FillColor}/>
        </svg>
    )
}
